import getUserValidationSchema from 'features/user/schema';

export default getUserValidationSchema(['email', 'password']);
